"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Pill = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", alignItems: "center", spacing: "-3.2rem" }, { children: children.map(function (child, index) {
            return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                    zIndex: children.length - index,
                    border: '2px solid',
                    borderColor: 'common.white',
                    borderRadius: 9999,
                } }, { children: child }), index));
        }) })));
};
exports.default = Pill;
